import {
  Directive,
  inject,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeatureFlagsV2Service } from 'src/app/core/services/feature-flags.v2.service';

@Directive({
  selector: '[appFeatureFlag]',
})
export class FeatureFlagDirective implements OnInit, OnDestroy {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private featureFlagService = inject(FeatureFlagsV2Service, {
    optional: true,
  });
  private destroy$ = new Subject<void>();
  private hasView = false;

  @Input('appFeatureFlag') flagName!: string;

  ngOnInit(): void {
    if (!this.flagName) {
      console.error('FeatureFlagDirective: No flag name provided.');
      return;
    }

    // If the feature flag service is absent (e.g. in simple unit tests), render by default.
    if (!this.featureFlagService) {
      this.ensureView();
      return;
    }

    this.featureFlagService
      .isEnabled(this.flagName)
      .pipe(takeUntil(this.destroy$))
      .subscribe((isEnabled) => {
        if (isEnabled) {
          this.ensureView();
        } else {
          this.clearView();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private ensureView(): void {
    if (!this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }

  private clearView(): void {
    if (this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
